import { dataLayerConfig, TAGButton } from '@aspendental/shared-components-web';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { FC, useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { containerWrapper, leftContainerStyle, rightContainerStyle, submitButton, title } from './LoginWithEmail.styles';
import LoginWithEmailForm from './LoginWithEmailForm';
import LoginWithEmailResendLink from './LoginWithEmailResendLink';
import LoginWithEmailTipsDialog from './LoginWithEmailTipsDialog';
import LoginWithEmailTipsDrawer from './LoginWithEmailTipsDrawer';
import { useEmailLogin } from '@src/services/useEmailLogin';
const LoginWithEmail: FC = () => {
  const payNowLink = 'https://www.aspendental.com/pay';
  const {
    isPending,
    emailLoginMutation
  } = useEmailLogin();
  const [isTipsDialogVisible, setIsTipsDialogVisible] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [email, setEmail] = useState('');
  const toggleTipsDialog = () => {
    setIsTipsDialogVisible(!isTipsDialogVisible);
  };
  const handleOnSubmit = async (emailPayload: FieldValues) => {
    await emailLoginMutation(emailPayload);
    dataLayerConfig({
      event: 'patient_services_login',
      step_name: 'authentication_1',
      aspen_action: 'link_sent',
      auth_method: 'none'
    });
    setEmail(emailPayload.email);
  };
  return <Box data-test-id="LoginWithEmailRoot" data-sentry-element="Box" data-sentry-component="LoginWithEmail" data-sentry-source-file="LoginWithEmail.tsx">
			<Box sx={title.wrapper} data-sentry-element="Box" data-sentry-source-file="LoginWithEmail.tsx">
				<Typography sx={title.header} variant="heroMedium" align="center" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmail.tsx">
					Patient Services
				</Typography>
				<Typography maxWidth={480} align="center" variant="bodyMediumBook" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmail.tsx">
					Fill out your patient forms, manage your appointments, and pay your bills. All in one place!
				</Typography>
			</Box>
			<Box sx={containerWrapper(isSmallScreen)} data-sentry-element="Box" data-sentry-source-file="LoginWithEmail.tsx">
				<Box sx={leftContainerStyle({
        isMediumScreen,
        isSmallScreen
      })} data-sentry-element="Box" data-sentry-source-file="LoginWithEmail.tsx">
					<Typography textAlign="center" color="text.light" variant="header1" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmail.tsx">
						Pay as a guest
					</Typography>
					<Typography textAlign="center" color="text.light" variant="bodyLargeBook" data-sentry-element="Typography" data-sentry-source-file="LoginWithEmail.tsx">
						View billing statements and make payments online.
					</Typography>
					<Box data-sentry-element="Box" data-sentry-source-file="LoginWithEmail.tsx">
						<TAGButton sx={submitButton} variant="primaryDefault" onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = payNowLink;
          }} data-sentry-element="TAGButton" data-sentry-source-file="LoginWithEmail.tsx">
							Pay Now
						</TAGButton>
					</Box>
				</Box>
				<Box sx={rightContainerStyle({
        isMediumScreen,
        isSmallScreen
      })} data-sentry-element="Box" data-sentry-source-file="LoginWithEmail.tsx">
					{!email ? <LoginWithEmailForm title="Sign in via email link" buttonText="Send link" isPending={isPending} handleOnSubmit={handleOnSubmit} /> : <LoginWithEmailResendLink handleOnSubmit={handleOnSubmit} email={email} toggleTipsDialog={toggleTipsDialog} />}
				</Box>
			</Box>
			{isSmallScreen ? <LoginWithEmailTipsDrawer isTipsDialogVisible={isTipsDialogVisible} toggleTipsDialog={toggleTipsDialog} /> : <LoginWithEmailTipsDialog isTipsDialogVisible={isTipsDialogVisible} toggleTipsDialog={toggleTipsDialog} />}
		</Box>;
};
export default LoginWithEmail;